import { LogGroup, Log } from "../.././MyHelpers";

export class ConstantSpeed
{
	public speed: number = 0;
	public targetDistance: number = 0;
	public targetDuration: number = 0;
	//public duration: number = 0;

	public defaultDistance: number = 0;
	public minimumDistance: number = 0;
	public passedMinimumDistance: boolean = false;

	public currentDistance: number = 0;

	public delayDuration: number = 0;
	public delayDistance: number = 0;

	protected logGroup: LogGroup = null;
	public constructor(logGroup: LogGroup)
	{
		this.logGroup = logGroup.Add("ConstantSpeed");
	}

	public Reset(): void {
		this.targetDistance = this.defaultDistance + this.delayDistance;
		this.targetDuration = this.targetDistance / this.speed;
		this.passedMinimumDistance = false;
		this.currentDistance = 0;
	}

	// public SetTargetDistance(targetDistance: number): boolean {
	// 	let success: boolean = false;
		
	// 	// can't set target distance to past position??
	// 	if (targetDistance >= this.currentDistance) {
	// 		success = true;

	// 		this.targetDistance = targetDistance;
	// 		this.targetDuration = this.targetDistance / this.speed;
	// 	} 
	// 	else {
	// 		Log.Error(this.logGroup, "Can't set target distance to past position");
	// 	}

	// 	return success;
	// }


	// public SetDefaultDistance(symbolHeight: number, delay: boolean = true) {
	// 	// end at the default distance, or as soon after as possible

	// 	let defaultDistance = this.defaultDistance;

	// 	if (this.currentDistance < this.targetDistance)
    //     {
	// 		// can end at the default distance
	// 		// Log.Debug(this.logGroup, "Can end at the default distance");
	// 		this.SetTargetDistance(this.defaultDistance);
	// 	}
	// 	else {
	// 		// we're already over default distance, end at the end of symbol

	// 		// Log.Debug(this.logGroup, "Ending spin as soon as possible");
	// 		defaultDistance = Math.ceil(this.currentDistance / symbolHeight) * symbolHeight;
	// 	}

	// 	if (delay) {
	// 		defaultDistance += this.delayDistance;
	// 	}

	// 	this.SetTargetDistance(defaultDistance);
	// }


    public TryEnd(symbolHeight: number, fast: boolean): void
    {
        fast = fast || this.currentDistance >= this.targetDistance;

        if (fast)
        {
            // end fast, next symbol
            let newTargetDistancePixels = this.currentDistance + symbolHeight
            this.SetTargetDistance(newTargetDistancePixels, symbolHeight);
        }
    }

    public SetTargetDistance(newTargetDistancePixels: number, symbolHeight: number)
    {
        // round to next symbol
        this.targetDistance = Math.ceil(newTargetDistancePixels / symbolHeight) * symbolHeight;
        this.targetDuration = this.targetDistance / this.speed;
    }

	public CalculateDistance(time: number): number {
		return this.speed * time;
	}
}